import { TSpeakerContent } from "../../../../../../../services/api/instances/meetingsApi/types";
import { GenericSelect } from "../../../../../../../shared/components/AppGenericSelect";
import styles from "./styles.module.css";

interface Props {
  speakers: Omit<TSpeakerContent, "speech_content" | "isActive">[];
  speaker: Omit<TSpeakerContent, "speech_content" | "isActive">;
  onSelectSpeaker: (
    speaker: Omit<TSpeakerContent, "speech_content" | "isActive"> | null
  ) => void;
  isDisabled?: boolean;
  className?: string;
}

export const SpeakerSelection = ({
  speakers,
  speaker,
  onSelectSpeaker,
  isDisabled,
  className,
}: Props) => {
  return (
    <GenericSelect<Omit<TSpeakerContent, "speech_content" | "isActive">>
      options={speakers}
      value={speaker}
      onChange={onSelectSpeaker}
      getLabel={(speaker) => speaker.speaker_name}
      getValue={(speaker) => speaker.speaker_group_key}
      isDisabled={isDisabled}
      className={styles["speakers-select"]}
    />
  );
};
